
  export default {
    mounted() {
      this.zoom = 1
      this.el.querySelectorAll("[data-zoom]").forEach((btn) => {
        btn.addEventListener("click", () => {
          const action = btn.dataset.zoom
          if (action === "in") this.zoom = Math.min(3, +(this.zoom + 0.25).toFixed(2))
          else this.zoom = Math.max(0.5, +(this.zoom - 0.25).toFixed(2))
          this.apply()
        })
      })
      this.apply()
    },
    // Re-assert the zoom after a LiveView patch: morphdom resets the
    // inline styles the hook wrote back to the server's static values, so
    // without this the zoom snaps to 100% on every re-render.
    updated() {
      this.apply()
    },
    apply() {
      const content = this.el.querySelector("[data-zoom-content]")
      const label = this.el.querySelector("[data-zoom-label]")
      if (!content) return
      const z = this.zoom
      if (this.el.dataset.kind === "pdf") {
        content.style.width = `${100 / z}%`
        content.style.height = `${100 / z}vh`
      }
      content.style.transform = `scale(${z})`
      if (label) label.textContent = `${Math.round(z * 100)}%`
    },
  }
